import React from 'react';
import SummaryBar from './SummaryBar';
import TypeDonut from './TypeDonut';
import CompletenessBar from './CompletenessBar';
import MissingFieldsTable from './MissingFieldsTable';
import DuplicatesPanel from './DuplicatesPanel';

export default function Dashboard({ audit }) {
  return (
    <div>
      {/* Row 1: Summary cards */}
      <SummaryBar audit={audit} />

      {/* Row 2: Donut chart + Metadata completeness */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <TypeDonut typeCounts={audit.type_counts} />
        <CompletenessBar
          requiredFields={audit.required_fields}
          optionalFields={audit.optional_fields}
          totalAssets={audit.total_assets}
        />
      </div>

      {/* Row 3: Missing fields + Duplicates */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <MissingFieldsTable requiredFields={audit.required_fields} />
        <DuplicatesPanel duplicates={audit.duplicates} />
      </div>
    </div>
  );
}
